/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Youtube_Region_1Inputs */

const en_live_caption_youtube_region_1 = /** @type {(inputs: Live_Caption_Youtube_Region_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top left`)
};

const fr_live_caption_youtube_region_1 = /** @type {(inputs: Live_Caption_Youtube_Region_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En haut à gauche`)
};

const de_live_caption_youtube_region_1 = /** @type {(inputs: Live_Caption_Youtube_Region_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oben links`)
};

const it_live_caption_youtube_region_1 = /** @type {(inputs: Live_Caption_Youtube_Region_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In alto a sinistra`)
};

const ru_live_caption_youtube_region_1 = /** @type {(inputs: Live_Caption_Youtube_Region_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вверху слева`)
};

const es_live_caption_youtube_region_1 = /** @type {(inputs: Live_Caption_Youtube_Region_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arriba a la izquierda`)
};

const zh_cn2_live_caption_youtube_region_1 = /** @type {(inputs: Live_Caption_Youtube_Region_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`左上`)
};

const ja_live_caption_youtube_region_1 = /** @type {(inputs: Live_Caption_Youtube_Region_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`左上`)
};

const hi_live_caption_youtube_region_1 = /** @type {(inputs: Live_Caption_Youtube_Region_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बाएं से बाएं`)
};

const pt_pt2_live_caption_youtube_region_1 = /** @type {(inputs: Live_Caption_Youtube_Region_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canto superior esquerdo`)
};

/**
* | output |
* | --- |
* | "Top left" |
*
* @param {Live_Caption_Youtube_Region_1Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_youtube_region_1 = /** @type {((inputs?: Live_Caption_Youtube_Region_1Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Youtube_Region_1Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_youtube_region_1(inputs)
	if (locale === "de") return de_live_caption_youtube_region_1(inputs)
	if (locale === "it") return it_live_caption_youtube_region_1(inputs)
	if (locale === "ru") return ru_live_caption_youtube_region_1(inputs)
	if (locale === "es") return es_live_caption_youtube_region_1(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_youtube_region_1(inputs)
	if (locale === "ja") return ja_live_caption_youtube_region_1(inputs)
	if (locale === "hi") return hi_live_caption_youtube_region_1(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_youtube_region_1(inputs)
	return en_live_caption_youtube_region_1(inputs)
});